import { render, staticRenderFns } from "./SendMailMiniTemplates.vue?vue&type=template&id=2757b38f&"
import script from "./SendMailMiniTemplates.vue?vue&type=script&lang=js&"
export * from "./SendMailMiniTemplates.vue?vue&type=script&lang=js&"
import style0 from "./SendMailMiniTemplates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports